import React, { useState } from 'react'
import { Row, Col } from 'reactstrap'
import { Link } from "react-router-dom"
import { ArrowLeft } from '@material-ui/icons';
import { TextField, Box } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Loader from "../../../components/Loader";
import axios from "../../../services/axios"
import moment from "moment"
import GanttChart from '../../common/Recommendations/Gantt'

function InspectorGantt({editMode = true}) {
    const [inspections, setInspections] = useState([])
    const [loading, setLoading] = useState(false)
    const [role, setRole] = useState("")
    const [zone, setZone] = useState("")
    const [selectedInspection, setselectedInspection] = useState({})
    const [recommendations, setrecommendations] = useState([])
    const [categories, setcategories] = useState([])
    const [loadGantt, setLoadGantt] = useState(false)

    const fetchInspections = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`/inspection_visits`);
            
            // Handle different response structures
            let inspectionsData = [];
            if (response.data && response.data.data) {
                // Handle paginated response
                inspectionsData = response.data.data;
            } else if (Array.isArray(response.data)) {
                // Handle direct array response
                inspectionsData = response.data;
            } else if (response.data && Array.isArray(response.data.data)) {
                // Another possible structure
                inspectionsData = response.data.data;
            } else {
                // Fallback to empty array
                console.warn('Unexpected response structure:', response.data);
                inspectionsData = [];
            }
            
            setInspections(inspectionsData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching inspections:', error);
            setInspections([]);
            setLoading(false);
        }
    }

    const refreshRecommendation = () => {
        if (!selectedInspection || !selectedInspection.visit_id) return;
        
        axios.get(`/recommendations/major/${selectedInspection.visit_id}`)
            .then(({ data }) => {
                // Handle different response structures here too
                if (data && Array.isArray(data)) {
                    setrecommendations(data);
                } else if (data && data.data) {
                    setrecommendations(data.data);
                } else {
                    setrecommendations([]);
                }
            })
            .catch(error => {
                console.error('Error fetching recommendations:', error);
                setrecommendations([]);
            });
    }

    const fetchNesCategories = () => {
        axios.get('/nes_categories')
            .then(({ data }) => {
                // Handle response structure
                if (data && Array.isArray(data)) {
                    setcategories(data);
                } else if (data && data.data) {
                    setcategories(data.data);
                } else {
                    setcategories([]);
                }
            })
            .catch(error => {
                console.error('Error fetching categories:', error);
                setcategories([]);
            });
    }

    React.useEffect(() => {
        fetchInspections();
        fetchNesCategories();
    }, []);

    const fetchRecommendations = (inspection) => {
        if (!inspection || !inspection.visit_id) {
            console.error('No inspection or visit_id provided');
            return;
        }
        
        setLoading(true);
        axios.get(`/recommendations/major/${inspection.visit_id}`)
            .then(({ data }) => {
                // Handle response structure
                let recData = [];
                if (data && Array.isArray(data)) {
                    recData = data;
                } else if (data && data.data) {
                    recData = data.data;
                }
                setrecommendations(recData);
                setLoadGantt(true);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching recommendations:', error);
                setrecommendations([]);
                setLoadGantt(false);
                setLoading(false);
            });
    }

    // Ensure inspections is an array before using map
    const inspectionOptions = Array.isArray(inspections) 
        ? inspections.map(ins => 
            `${ins.school_name} on ${moment(ins.present_visitation_date).format("YYYY-MM-DD")}`
          )
        : [];

    return (
        <React.Fragment>
            <div className="container-fluid">
                <Row className="position-center">
                    {loading && <Loader />}
                </Row>

                <Row className="align-items-center">
                    <Col sm={6}>
                        <div className="page-title-box">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>

                                <li className="breadcrumb-item active">Action Plans</li>
                            </ol>
                        </div>
                    </Col>

                    <Col sm="6">
                        <div className="float-right d-none d-md-block">
                            <Link className="btn btn-primary " to={`/`} ><ArrowLeft />Back</Link>
                        </div>
                    </Col>
                </Row>

                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <h3 className="card-title">Action Plans</h3>
                                <hr />
                                <div className="row">
                                    <div className="col-md-12">
                                        <Autocomplete
                                            fullWidth
                                            options={inspectionOptions}
                                            renderInput={(params) => <TextField {...params} label="Search Inspection name or date" />}
                                            onChange={(event, newValue) => {
                                                if (newValue) {
                                                    const f = newValue.split(' on ');
                                                    if (f.length === 2) {
                                                        const inspection = inspections.find(i => 
                                                            i.school_name === f[0] && 
                                                            moment(i.present_visitation_date).format("YYYY-MM-DD") === f[1]
                                                        );
                                                        if (inspection) {
                                                            setselectedInspection(inspection);
                                                            fetchRecommendations(inspection);
                                                        }
                                                    }
                                                }
                                            }}
                                            loading={loading}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12 mt-3">
                                    {loadGantt && selectedInspection && selectedInspection.visit_id && (
                                        <GanttChart 
                                            editMode={editMode} 
                                            visit={selectedInspection} 
                                            updateRecommendationsList={refreshRecommendation} 
                                            categories={categories} 
                                            recommendations={recommendations} 
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        &nbsp;
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default InspectorGantt;